<template>
        <div class="head">
            <div class="background">
                <div class="headTop">公司简介</div>
                <div class="headContent">蓝色火焰科技成都有限公司，是一家集话费整合营销方案、智慧监管系统开发的综合业态服务的高新科创企业。公司依托上游供货商独占的核心通道资源，开发的以话费为核心的整合营销系统，以精准服务在行业占据一席之地，先后成为小米、同程、360、滴滴等国内知名互联网平台代运营服务商。同时，2021年公司再度发力，开发了“三码合一·一店一码智慧放心码”监管系统，以展示商户信用信息切入，融合支付买单功能，推进智慧食安治理体系建设，助推食品安全监管水平整体提升。自成立以来，公司持续引入人才济济的研发阵容和具有先进理念的运营团队，创始人 来自腾讯微信电商团队，及核心技术骨干大多来自腾讯、阿里等国内知名互联网公司，未来将继续致力于为市场提供优质的产品、专业的服务。</div>
            </div>
            <div class="headTop" style="padding-bottom:10px">新闻动态</div>
            <div class="headText">这里有行业最新动态、公司大事件以及未来规划</div>
            <div  v-for="item in hove.capability" :key="item.id">
                 <div class="headState">
                <div class="headImage"><el-image style="height:100px;width:120px" :src="item.UsImg"></el-image></div>
                <div class="headProd" >
                    <div class="headProdTop">{{item.title}}</div>
                    <div>{{item.content}}</div>
                </div>
                <div class="headButn"><el-button type="primary" @click="onshow(item)" round>查看详情</el-button></div>
            </div>
            </div>
            <!-- <transition name="el-fade-in">
                <el-dialog  v-show="show" fullscreen center :title="data.title" :visible.sync="show">
                    <div class="flexCenter">
                        <div class="UsDate">{{data.date}}</div>
                        <div v-for="(item,index) in data.qeury" :key="index">
                            <div class="UsTitle"></div>
                            <div class="UsContent" v-html="item.center"></div>
                            <el-image v-if="item.UsImg" style="padding:15px 0" v-bind:src="item.UsImg"></el-image>
                        </div>
                    </div>
                    <div  style="margin:15px" class="dialog-footer">
                        <el-button  type="primary" @click="show = false">返 回</el-button>
                    </div>
                </el-dialog>
            </transition> -->
        </div>
</template>

<script>
 import list from "./list.json"
export default {
    data(){
        return{
            hove:{
                img:require("./../assets/endMe.png"),
                img1:require("./../assets/endMe.png"),
                img2:require("./../assets/endMe.png"),
                capability:[],
            },
            show:false,
            dialogTableVisible: false,
            dialogFormVisible: false,
            formLabelWidth: '120px',
            data:{}
        }
    },
    created(){
        console.log(list)
       this.hove.capability = list.capability
    },
    methods:{
        onshow(item){
            localStorage.setItem("AboutUsDetail",JSON.stringify(item))
            // this.show = !this.show
            // this.data = item
            // console.log(this.data)
            this.$router.push({path:"/AboutUsDetail"})
        }
    }
}
</script>

<style scoped>
  @import "./../style/index.scss";
.flexCenter{
    text-align: center;
    overflow-x: hidden;
    height: 100%;
    margin: 0 auto;
    width: 80%;
}
/deep/ .el-dialog__title{
    font-weight: 900;
    font-size: 20px;
}
.UsDate{
    font-size: 13px;
    color: #858585;
    margin: 15px 0px;
}
.UsContent{
    text-align: left;
    line-height: 25px;
}
.dialog-footer{
    display: flex;
    justify-content: flex-end;
    margin-right: 150px;
}
/* 详情页 */


  .head{
    /* height: 130rem; */
    /* background: radial-gradient("#f4f8ff","#f4f8ff"); */
    /* background: #f4f8ff; */
    background:linear-gradient(#f4f8ff,#f4f8ff,#a8c3ff77);
}
  .background{
      background: url("./../assets/AboutUs.png");
      background-size: 100% 100%;
      height: 356px;
  
  }
  .headTop{
      font-size: 40px;
      font-family: "ku";
      color:#496DFA;
      text-align: center;
      padding: 30px 0px 30px 0px;
  }
  .headContent{
      color: #A6AABE;
      font-size: 16px;
      width: 65%;
      line-height: 30px;
      margin: 0 auto;
      position: relative;
      left: 30px;
  }
  .headText{
      color: #A6AABE;
      font-size: 13px;
      text-align: center;
      padding-bottom: 30px;
  }
    .headState{
        display: flex;
        justify-content:center;
        width: 100%;
        border-top: 0px;
        border-left: 0px;
        border-right: 0px;
        border-bottom: 2px solid red;
        border-image:linear-gradient(to right,transparent,transparent,#A6AABE,#A6AABE,#A6AABE,transparent,transparent ) 1 10;
        margin-top: 10px !important;
    }
    .headProd{
        width: 50%;
        padding: 20px;
        font-size: 12px;
        color: #A6AABE;
    }
    .headProdTop{
        color:#050505;
        font-size:16px;
        font-weight:800;
        position: relative;
        top: -10px;
        left: -10px;
    }
    .headButn{
        display: flex;
        align-items: center;
    }
    .headButn .el-button--primary{
        background: #496DFA;
        color: white;
        padding: 7px 10px 7px 10px;
        font-size: 12px;
    }
</style>


// WEBPACK FOOTER //
// src/components/AboutUs.vue


// WEBPACK FOOTER //
// src/components/AboutUs.vue